import { render, staticRenderFns } from "./ContentWithSidebar.vue?vue&type=template&id=0fc288a0"
import script from "./ContentWithSidebar.vue?vue&type=script&lang=js"
export * from "./ContentWithSidebar.vue?vue&type=script&lang=js"
import style0 from "./ContentWithSidebar.vue?vue&type=style&index=0&id=0fc288a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports